<template>

  <!-- Все компоненты, которые здесь показываем,
  должны в шаблоне быть обернуты в тег <default-view>
  со слотами header, toolbar-items, content
   -->
  <router-view/>


</template>

<script>

	import {mapGetters} from 'vuex'
	import api from './api'
	// import {ROLE_CURATOR, ROLE_ADMIN} from "./store/auth"

	export default {
		name: 'App',

		data() {
			return {
				time_stamp: null,
				timer: null,
				title: 'LIS',
			}
		},

		computed: {
			...mapGetters(
				'auth', ['isAuthenticated',]
			),
		},

		watch: {
			isAuthenticated: function () {
				if (!this.isAuthenticated) {
					this.$router.push('/login')
				}
			}
		},

		created: function () {
			this.time_stamp = (new Date()).getTime()
			// this.timer = setInterval(this.checkBuildJS, 360000) //TODO: build.js has disappeared

			///
			// this.$vuetify.theme.error = "#cc9900"
			///
		},

		beforeDestroy: function () {
			clearInterval(this.timer)
		},

		methods: {

			checkBuildJS() {
				return api.others.checkBuildJS()
					.then((response) => {
						let last_modified = response.data
						if (last_modified > this.time_stamp) {
							this.$store.dispatch('error/error_occurred',
								{
									error:
										{
											message:
											"The source code was updated on server, " +
											"it is strongly recommended to reload the page (Ctrl+F5)"
										},
									ok: false
								}
							)
							this.time_stamp = last_modified
						}
					})
			},
		}
	}
</script>
